import React from "react";
import { CardFooter, Button } from "reactstrap";
import DocumentPopup from "Components/Modal/DocumentModel";
import { useGebruikerContext } from "../../Context/GebruikerContext";
import { ReactComponent as BackIcon } from "../../../../../assets/utils/images/svgs/arrow-left.svg";
import { ReactComponent as AddIcon } from "../../../../../assets/utils/images/svgs/addBlue.svg";
import { useDocumentenContext } from "./context/DocumentenContext";

export default function Footer() {
	const {
		filterCommunity,
		setFilterCommunity,
		adminCommunityList,
		setActiveTab,
		userTabs,
		currentUser,
		fetchUserDetails,
	} = useGebruikerContext();
	const { saveFile, file, openModel, toggleProfileCropPopup, handleCroppedImage } =
		useDocumentenContext();

	return (
		<div className="chat-layout-footer">
			<CardFooter className="chat-layout-footer__inner gebruikers-footer">
				<div className="d-flex gap-3 w-100">
					<select
						className={`form-select w-auto`}
						value={filterCommunity[0]?.iCommunityId}
						onChange={(e) => {
							setFilterCommunity(
								adminCommunityList.filter(
									(item) => item?.iCommunityId === Number(e.target.value)
								)
							);
						}}
					>
						<option value={""} disabled>
							Alle besturen
						</option>
						{adminCommunityList.map((item) => {
							return (
								<option value={item.iCommunityId} key={item.iCommunityId}>
									{item.vCommunityName}
								</option>
							);
						})}
					</select>
					<Button
						outline
						className="btn-outline-primary-blue d-flex justify-content-center align-items-center gap-2"
						onClick={toggleProfileCropPopup}
						type="button"
						color="primary"
					>
						Document <AddIcon />
					</Button>
					<Button
						outline
						className="btn-outline-primary-blue ms-auto me-3"
						onClick={() => {
							setActiveTab(userTabs.Instellingen);
						}}
						type="button"
						color="primary"
					>
						<BackIcon />
					</Button>
					<DocumentPopup
						type="Gebruikers"
						filterCommunity={filterCommunity}
						currentUser={currentUser}
						isOpen={openModel}
						togglePopup={toggleProfileCropPopup}
						croppedFile={handleCroppedImage}
						saveFile={saveFile}
						doc={file}
						updateData={fetchUserDetails}
						classes="document-modal-style modal-centered"
					/>
				</div>
			</CardFooter>
		</div>
	);
}
